import React from "react";
import { useNavigate } from "react-router";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import moment from "moment";
import Header from "../../../../../../components/wizard/Header";
import Footer from "../../../../../../components/wizard/Footer/Footer";
import useAuth from "../../../../../../hooks/useAuth";
import ActionsButton from "./ActionsButton";
import useMutation from "../../../../../../hooks/useMutation";
import { UPDATE_INTERNAL_WORK_ORDER_MUTATION } from "../../../../../../constants/graphql/mutations";
import { serverFormatSeconds } from "../../../../../../utils/dates";
import useHasAdditionalCharges from "src/components/capture/ReceivingWizard/hooks/useHasAdditionalCharges";
import useHasEnabledIntegration from "src/hooks/useHasEnabledIntegration";

export default function Details({ project, internalWorkOrder }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { settings } = user.company;
  const [saveInternalWorkOrder] = useMutation(UPDATE_INTERNAL_WORK_ORDER_MUTATION);
  const hasAdditionalCharges = useHasAdditionalCharges(project, "outbound");
  const { hasIntegration } = useHasEnabledIntegration(project);
  const totalSteps = (hasAdditionalCharges ? 4 : 3) + (hasIntegration ? 1 : 0);

  const nextStep = () => {
    // Set pickingStartTime when user clicks Start button
    if (!internalWorkOrder.pickingStartTime) {
      const pickingStartTime = moment().format(serverFormatSeconds);
      saveInternalWorkOrder({
        variables: {
          id: internalWorkOrder.id,
          input: { pickingStartTime },
        },
      });
    }

    const params = new URLSearchParams(window.location.search);
    params.set("step", "items");
    navigate({ search: params.toString() });
  };

  return (
    <>
      <Header title="Internal Order Details" info={internalWorkOrder.internalWorkOrderNumber} />
      <Box
        p={2}
        minHeight={400}
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
      >
        <Box>
          <Grid container spacing={1.5}>
            <Grid size={12}>
              <TextField
                size="small"
                fullWidth
                disabled
                value={project.name}
                label={`${settings.filter_field2} Name`}
              />
            </Grid>
            <Grid size={6}>
              <TextField
                size="small"
                fullWidth
                disabled
                value={
                  internalWorkOrder.deadlineDate
                    ? moment(internalWorkOrder.deadlineDate).format("MM/DD/YYYY")
                    : ""
                }
                label="Complete By"
              />
            </Grid>
            <Grid size={6}>
              <TextField
                size="small"
                fullWidth
                disabled
                value={internalWorkOrder.user.email || ""}
                label="Create By"
              />
            </Grid>
            <Grid size={12}>
              <TextField
                size="small"
                multiline
                fullWidth
                disabled
                value={internalWorkOrder.comment || ""}
                label="Comments"
                minRows={4}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box mt={2}>
        <Footer
          step={0}
          steps={totalSteps}
          startTime={internalWorkOrder?.pickingStartTime}
          completeTime={internalWorkOrder?.pickingCompleteTime}
        >
          <ActionsButton onClick={nextStep} />
        </Footer>
      </Box>
    </>
  );
}
